import { Link } from "react-router-dom";
import { useAuthStore } from "@/stores/authStore";
import { useUserApplications } from "@/hooks/useUserApplications";
import { convertSnakeCaseToTitleCase } from "@/lib/utils";

export function Dashboard() {
  const { permissions, user } = useAuthStore();
  const { applications, loading, error } = useUserApplications();

  return (
    <div className="space-y-6 p-6">
      <div>
        <h1 className="text-3xl font-bold">Welcome to Fission AI Portal</h1>
        <p className="text-muted-foreground mt-2">
          {user ? `Welcome back, ${user.displayName || user.username || user.email}! ` : ""}
          Select an application to get started
        </p>
        {permissions.length > 0 && (
          <p className="text-sm text mt-1 text-black text-bold font-bold capitalize">
            Your permissions: {convertSnakeCaseToTitleCase(permissions.join(", "))}
          </p>
        )}
      </div>

      {error ? (
        <div className="rounded-md border border-red-300 bg-red-50 p-3 text-sm text-red-700">{error}</div>
      ) : null}

      {loading ? (
        <div className="flex items-center justify-center py-6">
          <div className="h-10 w-10 animate-spin rounded-full bg-gradient-to-r from-primary/60 via-primary to-primary/80 p-[3px]">
            <div className="h-full w-full rounded-full bg-background" />
          </div>
        </div>
      ) : null}

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-6 h-24">
        {applications.map((app) => (
          <Link
            key={app.id}
            to={app.route}
            className="group relative rounded-xl border border-primary/20 bg-primary/5 p-4 transition-all hover:bg-primary/10 hover:shadow-sm"
          >
            <div className="flex items-start gap-3">
              {app.icon ? (
                <img
                  src={app.icon}
                  alt={`${app.appName} logo`}
                  className="h-8 w-8 shrink-0 rounded-md object-cover"
                />
              ) : (
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-primary/80" />
              )}
              <div className="min-w-0 flex-1">
                <h3 className="truncate text-black font-semibold">{app.appName}</h3>
                {app.description && (
                  <p className="mt-1 text-xs text-muted-foreground line-clamp-2">
                    {app.description}
                  </p>
                )}
              </div>
            </div>
          </Link>
        ))}
      </div>

      {!loading && applications.length === 0 && (
        <div className="text-center py-12">
          <p className="text-muted-foreground">
            No applications available.
          </p>
        </div>
      )}
    </div>
  );
}
